import React from 'react';

/**
 * One colour block on the Home Learning hub. Full size it shows a big tile whose tagline slides in
 * on hover/focus (always visible on touch screens, which have no hover). Compact, it is a chip in
 * the strip that stays on top once a section is open; `active` marks the open one. `onHoverChange(true|false)`
 * reports pointer hover and keyboard focus on the big tile (Addy reacts to it).
 */
export default function SectionTile({ title, tagline, icon: Icon, colour, onClick, compact = false, active = false, testId, onHoverChange }) {
  if (compact) {
    return (
      <button
        type="button"
        onClick={onClick}
        aria-pressed={active}
        data-testid={testId}
        className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold shadow-sm transition-all duration-300 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-300 motion-reduce:transition-none ${colour} ${
          active ? 'scale-105 ring-4 ring-white shadow-lg' : 'opacity-60 hover:opacity-100'
        }`}
      >
        <Icon className="h-4 w-4" aria-hidden="true" />
        {title}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={() => onHoverChange?.(true)}
      onMouseLeave={() => onHoverChange?.(false)}
      onFocus={() => onHoverChange?.(true)}
      onBlur={() => onHoverChange?.(false)}
      data-testid={testId}
      className={`group relative flex min-h-[160px] flex-col justify-between overflow-hidden rounded-3xl p-6 text-left shadow-md transition-all duration-300 ease-out hover:-translate-y-1.5 hover:shadow-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-300 active:scale-95 motion-reduce:transform-none motion-reduce:transition-none md:min-h-[200px] ${colour}`}
    >
      <Icon
        className="absolute -right-4 -top-4 h-28 w-28 opacity-15 transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110 motion-reduce:transform-none"
        aria-hidden="true"
      />
      <Icon className="h-10 w-10" aria-hidden="true" />
      <div>
        <span className="block text-2xl font-extrabold md:text-3xl">{title}</span>
        <span className="mt-1 block text-base font-semibold transition-all duration-300 md:translate-y-2 md:opacity-0 md:group-hover:translate-y-0 md:group-hover:opacity-100 md:group-focus-visible:translate-y-0 md:group-focus-visible:opacity-100 motion-reduce:transform-none">
          {tagline}
        </span>
      </div>
    </button>
  );
}
